// extracted by mini-css-extract-plugin
module.exports = {"problem":"Problem_problem__8ku5_","buttonContainer":"Problem_buttonContainer__a6qWS","uploaded":"Problem_uploaded__1-EAJ","footer":"Problem_footer__sG9bD"};